<template>
  <a-result class="box_result" status="success" :title="$Enum.TextEnum.SuccessLogin" sub-title="正在返回..." />
</template>

<script lang="ts" type="text/tsx">
import { DataInterface, ParamEnum } from '@interface/public';

export default {
  name: 'back',
  mounted(): void {
    !$Store.User().operate && $Store.User().$patch({
      operate: $Enum.OperateEnum.Login
    });
    $RQ.RefreshToken(() => {
      const source: string = decodeURIComponent($Store.User().source || $Config.Href.store);
      const operate: string = decodeURIComponent($Store.User().operate);
      const currentUrl = window.location.href;
      const isEnv35 = currentUrl.includes('monn35rc');

      let param: any = {};

      // $Store.User().clearSource();
      !$Store.User().userID &&
      $Store.User().updateInfo({
        userID: '-'
      });
      !$Store.User().username &&
      $Store.User().updateInfo({
        username: $Store.User().userID || '-'
      });
      $Store.User().token !== '' && (param[ParamEnum.Token] = $Store.User().token);
      $Store.User().userID !== '' && (param[ParamEnum.UserID] = $Store.User().userID);
      $Store.User().username !== '' && (param[ParamEnum.UserName] = $Store.User().username);
      $Store.User().operate !== '' && (param[ParamEnum.Operate] = $Store.User().operate);
      // $RQ.PushWebHookFeiShu(
      //   `页面返回: ${$Store.User().username}`,
      //   `source: ${source}, operate: ${operate},window.wx:${!window.wx}`
      // );
      if (source === 'wechat_login' || (operate === 'wechat_login'&&!isEnv35)) {
        if (!window.wx) {
          location.href = $FN.Url.set(param, 'wechat_login');
          return;
        }
        // 1. 执行登出逻辑
        $RQ.SSO.logout();
        // 2. 直接获取登录页路径并跳转
        // 假设 $Enum.AppletsRouterEnum.Login 是 '/pages/login/index' 这种路径字符串
        const loginPath = $Enum.AppletsRouterEnum.Login;

        // 使用 redirectTo (关闭当前WebView页，去登录页) 
        // 或者 use reLaunch (关闭所有页面去登录页)
        // 不建议用 navigateTo，因为你之前用的是 navigateBack，说明你想关掉当前页
        window.wx.miniProgram.redirectTo({
          url: loginPath
        });
        // 不再需要 postMessage 和 navigateBack
        return;
      }
      if (source === 'cloud_login') {
        if (!window.GFConfig) {
          location.href = $FN.Url.set(param, source);
          return;
        }

        $RQ.SSO.logout();

        window.GFPostMessage?.('GFUserData', {
          token: param[ParamEnum.Token],
          id: param[ParamEnum.UserID],
          name: param[ParamEnum.UserName]
        });
        return;
      }

      $FN.Url.isLink(source)
        ? (location.href = $FN.Url.set(param, source))
        : this.$router.push(source);
    });
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}sso/';
</style>